// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Button from 'components/Button';
import SectionHeader from 'components/SectionHeader';
import Link from 'components/Link';
import seideman5 from 'images/seideman-5.jpg';
import KidneyIcon from 'components/KidneyIcon';
import { sendEvent } from 'lib/analytics';

// local
import styles from './StonesSection.pcss';

const learnMore = 'https://www.ohsu.edu/doernbecher/kidney-stones';

export default class StonesSection extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
  }
  static defaultProps = {}
  
  handleLearnMore = () => sendEvent('learn-more', 'stones')
  
  render() {
    const { className } = this.props;
    
    const classNames = classnames(className, styles.stonesSection);
    return (
      <div
        id={ 'stones' }
        className={ classNames }
      >
        
        <div className={ styles.content }>
          <SectionHeader className={ styles.title } image={ <KidneyIcon />  }>
            { 'Kidney Stones' }
          </SectionHeader>
          <p>
            { `
                With the rate of kidney stones in kids on the rise, here at Doernbecher 
                we have created a multidisciplinary team of specialists to care for kids with stone disease.
              ` }
          </p>
          <p>
            { `
                Doctor Seideman has partnered with 
                Pediatric Nephrology and a Dietician to provide comprehensive treatments 
                and prevention planning for children with kidney stones.
              ` }
          </p>
          <Link
            className={ styles.learnMore }
            to={ learnMore }
            onClick={ this.handleLearnMore }
            title={ 'Learn more about kidney stone treatment' }
          >
            <Button className={ styles.button } color={ 2 } tabIndex={ -1 }>{ 'Learn About Stones' }</Button>
          </Link>
        </div>
        
        <div className={ styles.img }>
          <div className={ styles.wrap }>
            <img alt={ 'doctor casey seideman' } src={ seideman5 } />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StonesSection/index.jsx